<template>
  <BaseSelect v-bind="$attrs"
              :value="currentCurrency"
              :options="currencies"
              textKey="currency"
              @input="onInput"
              :getOptionText="getOptionText"
  />
</template>

<script>
  export default {
    name: 'CurrencySelect',
    data() {
      return {}
    },
    computed: {
      currencies() {
        return this.$store.state.currencies
      },
      currentCurrency() {
        return this.$store.state.currentCurrency
      }
    },
    methods: {
      onInput(event) {
        const currentCurrency = this.currencies.find(currency => currency.id === +event.id)
        if (currentCurrency) {
          this.$store.dispatch('changeCurrentCurrency', currentCurrency)
        }
      },
      getOptionText(option) {
        return option.currency === 'ALL'
          ? this.$tGlobal('currency_all')
          : `${option.currency} / ${option.symbol}`
      }
    }
  }
</script>

<style lang="less">

</style>
